import { hash } from '@ember/helper';

import { eq, or } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsDigitalOrderConfigComponent extends Component {
  // Defaults
  sourceTypes = ['product', 'download', 'external_promoter'];

  // Getter and setter
  get sourceTypeOptions() {
    return labelValueOptions.call(this, this.sourceTypes, [
      'forms.digital-order-config.options.sourceType',
    ]);
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='sourceType'
              @type='select-value'
              @options={{this.sourceTypeOptions}}
            />

            <fieldset.field @property='articleNumber' />
            <fieldset.field @property='headline' />
            <fieldset.field @property='artist' />
            <fieldset.field @property='articleImageUrl' />

            {{#if
              (or
                (eq @model.sourceType 'product')
                (eq @model.sourceType 'external_promoter')
              )
            }}
              <fieldset.field @property='voucherUrl' />
              <fieldset.field @property='campaign' />
              <fieldset.field @property='releaseDate' @type='date' />
            {{/if}}

            {{#if (eq @model.sourceType 'product')}}
              <fieldset.field @property='validityPeriod' />
            {{/if}}

            {{#if (eq @model.sourceType 'download')}}
              <fieldset.field
                @property='downloadAsset'
                @type='belongs-to'
                @on={{hash openNewRecord=false}}
              />
              <fieldset.field @property='watermark' @type='checkbox' />
            {{/if}}
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
